module.exports = __webpack_public_path__ + "img/avatar.732b8d49.png";